import { mountGame } from '../render/three/game-app.js';
import { tripeaksSpec } from '../variants/tripeaks/spec.js';

await mountGame(tripeaksSpec);
